import sleep from '../sleep';

export default (fn, minTimeInMillisec) => async (...args) => {
  const [response] = await Promise.all([fn(...args), sleep(minTimeInMillisec)]);

  return response;
};
